<template>
  <div></div>
</template>

<script>
import * as semver from 'semver'

const baeminOneAppVersion = '11.0.0'

export default {
  name: 'CompleteOrder',
  created() {
    const badgeUrl = process.env.VUE_APP_ORDER_BADGE_URL
    const ord = `{"${this.orderId}":${this.getUnixMillisecondTimestamp()}}`
    const queryString = `showOrderBadge_ordType=market&showOrderBadge_ord=${encodeURIComponent(ord)}`
    setTimeout(() => (window.location.href = `${badgeUrl}?${queryString}`), 100)

    let deliveryTrackingUrl = process.env.VUE_APP_DELIVERY_TRACKING_URL

    if (semver.gte(this.appVersion, baeminOneAppVersion))
      deliveryTrackingUrl = process.env.VUE_APP_BAEMIN_ONE_DELIVERY_TRACKING_URL

    setTimeout(() => (window.location.href = `${deliveryTrackingUrl}${this.orderId}`), 400)
  },
  data() {
    return {
      orderId: this.$route.query.id,
      appVersion: this.$route.query.appVersion || '0.0.0'
    }
  },
  methods: {
    getUnixMillisecondTimestamp() {
      return this.$moment(Date.now()).add(3, 'hours').locale('ko').format('x')
    }
  }
}
</script>
